import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { CoinConfigService } from '../../../_services/coinconfig.service';
import { CoinModel } from '../../../_models/coin';
import { UppercaseDirective } from '../../../_directives/uppercase.directive';

@Component({
    selector: 'app-edit-coin',
    templateUrl: './edit-coin.component.html',
    styleUrls: ['./edit-coin.component.css']
})
export class EditCoinComponent extends DialogComponent<CoinModel, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string = '';
    messages: any[] = [];
    returnUrl: string;
    pairs: any[] = [];
    pairName : any[] = [];
    pair: number = 1;
    emaPeriod1: number = 30;
    emaPeriod2: number = 50;
    coinId: string;
    coinName: string;
    focusEventEmitter = new EventEmitter<boolean>();
    isValidateEma: any = true;
    messageValidateBothEma: string = '';

    constructor(
        dialogService: DialogService, 
        private coinConfigService: CoinConfigService
    ) {
        super(dialogService);
    }

    ngOnInit() {
        this.pairs.forEach(element => {
            this.pairName[element.id] = element.name;
        });

        this.loading = true;
        this.model.emaPeriod1 = this.emaPeriod1;
        this.model.emaPeriod2 = this.emaPeriod2;

        this.coinConfigService.get(this.coinId).subscribe(data => {
            this.model.emaPeriod1 = data.ema_period_1;
            this.model.emaPeriod2 = data.ema_period_2;
        }, error => {
            
        }, () => {
            this.loading = false;
        });
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    edit() {
        this.loading = true;
        this.message = '';
        this.model.id = this.coinId;
        this.model.market_id = $('#market').val();

        this.coinConfigService.edit(this.model).subscribe(data => {
            if (data.error) {
                this.messages = data.message;
            }
            else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }

    checkBothEMA() {
        let currentEMA1 = this.model.emaPeriod1;
        let currentEMA2 = this.model.emaPeriod2;
        this.isValidateEma = true;
        if (currentEMA1 == currentEMA2) {
            this.isValidateEma = false;
            this.messageValidateBothEma = "EMA1及びEMA2が同じです。";
        }
    }
}




// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coinconfig/edit-coin/edit-coin.component.ts